import { axiosInstance } from '@/lib/utils/axios-instance';
import { endpoints } from '@/api';
import type {
  PaginatedData,
  PaginatedRequestResponse,
  RequestResponse,
} from '@/types';
import type { Transaction } from '@/types';

export interface TransactionFilters {
  status?: string;
  search?: string;
}

export const fetchTransactions = async (
  filters: TransactionFilters = {}
): Promise<PaginatedData<Transaction[]>> => {
  const params: Record<string, string> = {};
  if (filters.status) params.status = filters.status;
  if (filters.search) params.search = filters.search;

  const response = await axiosInstance.get<
    PaginatedRequestResponse<Transaction[]>
  >(endpoints.transactions, { params });

  return response.data.data;
};

export const fetchTransactionById = async (
  id: string | number
): Promise<Transaction> => {
  const response = await axiosInstance.get<RequestResponse<Transaction>>(
    `${endpoints.transactions}/${id}`
  );

  return response.data.data;
};
